import { Grid as KendoGrid } from "@progress/kendo-react-grid";
import "./Extensions/DataFilterBy";
import "./Extensions/DataOrderBy";
import "./Extensions/DataPaged";
import "./Extensions/DataWithEditfield";
import { Theme } from "@mui/material";
import styled from "styled-components";
import { ReactNode } from "react";

type Props = {
  height?: string;
  hideInlineFilterOperator?: boolean;
  muiTheme: Theme;
  children?: ReactNode;
};

const customFilterButtonClassFrom = (theme: Theme) =>
  `.k-clear-button-visible {
    color: ${theme.palette.primary.main};
  }`;

function customPagerItemsClass(theme: Theme) {
  return `.k-pager-numbers .k-link.k-state-selected {
    background-color: ${theme.palette.primary.main};
    color: #000;
  }`;
}

function customGridCellInEditMode(theme: Theme) {
  return `.k-master-row.k-grid-edit-row > .k-grid-edit-cell > .k-input {
    border: 1px solid ${theme.palette.text.disabled};
    border-radius: 4px;
  }`;
}

const StyledKendoGrid = styled(KendoGrid)<Props>`
  ${(props) => (props.scrollable ? "width: 100%;" : "")};

  ${(props) => (props.height ? `height: ${props.height};` : "")};

  ${(props) => customFilterButtonClassFrom(props.muiTheme)};

  ${(props) => customPagerItemsClass(props.muiTheme)};

  ${(props) => customGridCellInEditMode(props.muiTheme)};

  .k-filtercell-operator {
    display: ${(props) => (props.hideInlineFilterOperator ? "none" : "block")};
  }

  .k-filtercell-operator {
    display: ${(props) => (props.hideInlineFilterOperator ? "none" : "block")};
  }

  .k-grid-edit-row td > .k-checkbox {
    vertical-align: top;
  }

  .k-edit-cell,
  .k-command-cell,
  .k-grid-edit-row td {
    padding: 8px 12px;
  }

  .k-grid-toolbar {
    justify-content: right;

    button {
      margin-right: 0.5em;
      font-size: small;
    }

    a {
      margin-right: 10px;
      top: initial;
    }
  }
`;

export default StyledKendoGrid;
